export enum TransferType {
    Upload,
    Download
}
